/* Skio dynamic-box cart contract, shared by the PDP and focused contract tests. */
((scope) => {
  const R = typeof module !== 'undefined' && module.exports ? require('./v2-commerce-rules.js') : scope.MettaV2Rules;
  const id = value => String(value ?? '').split('/').pop();
  function plans(config) {
    return (config.sellingPlanGroup || []).filter(plan => String(plan.interval).toUpperCase() === 'WEEK' && Number(plan.intervalCount) > 0 && /^\d+$/.test(id(plan.gid)))
      .slice().sort((a, b) => Number(a.position) - Number(b.position));
  }
  function volumeDiscount(config, count) {
    return Object.entries(config.percentDiscountTier || {}).reduce((best, [minimum, percent]) => count >= Number(minimum) ? Math.max(best, Number(percent)) : best, 0);
  }
  function unitPrice(row, mode, plan, discount = 0) {
    const allocation = row.allocations.find(item => id(item.id) === id(plan?.gid));
    const base = mode === 'subscription' ? allocation?.price : row.price;
    if (!Number.isFinite(base)) return null;
    return Math.round(base * (1 - discount / 100));
  }
  function selection({ boxId, config, rows, mode, planId, boxIndex, commerce, currency }) {
    const selected = rows.filter(row => row.quantity > 0);
    const count = selected.reduce((sum, row) => sum + row.quantity, 0);
    const plan = plans(config).find(item => id(item.gid) === id(planId));
    const minimum = config.oneBox ? 1 : Number(config.sizeRange?.[0]);
    const maximum = config.oneBox ? Infinity : Number(config.sizeRange?.[1]);
    let error = null;
    if (!boxId || !Number.isInteger(minimum) || minimum < 1 || (!config.oneBox && !Number.isInteger(maximum)) || maximum < minimum) error = 'configuration';
    else if (count < minimum) error = 'minimum';
    else if (count > maximum) error = 'maximum';
    else if (!['subscription', 'onetime'].includes(mode)) error = 'configuration';
    else if (mode === 'subscription' && !plan) error = 'plan';
    else if (config.oneBox && selected.some(row => !config.variantIds.includes(id(row.id)))) error = 'unavailable';
    else if (selected.some(row => !row.available || !/^\d+$/.test(id(row.id)) || !Number.isInteger(row.quantity))) error = 'unavailable';
    commerce = config.oneBox ? config.commerce : commerce;
    let discount = commerce ? 0 : volumeDiscount(config, count);
    const prices = selected.map(row => unitPrice(row, mode, plan, discount));
    if (!error && prices.some(price => price === null)) error = 'plan';
    const quote = commerce ? R.quote(selected.map((row, index) => ({ id: id(row.id), quantity: row.quantity, unitPrice: prices[index], fullPrice: row.price, eligible: config.oneBox ? config.variantIds.includes(id(row.id)) : row.eligible === true })), commerce, { currency }) : null;
    if (quote) { if (!error && quote.error) error = quote.error; discount = quote.discountPercent || 0; }
    return {
      quote,
      error, count, minimum, maximum, discount, plan,
      total: quote ? quote.total : prices.reduce((sum, price, i) => sum + (price || 0) * selected[i].quantity, 0),
      meals: selected.reduce((sum, row) => sum + row.meals * row.quantity, 0),
      items: error ? [] : selected.map(row => ({
        id: id(row.id), quantity: row.quantity,
        properties: { _dynamicBoxIndex: config.oneBox ? 0 : boxIndex, _dynamicBoxId: boxId },
        ...(mode === 'subscription' ? { selling_plan: id(plan.gid) } : {})
      }))
    };
  }
  const api = { id, plans, unitPrice, volumeDiscount, selection };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.MettaV2Purchase = api;
})(typeof window === 'undefined' ? globalThis : window);
